import { render, staticRenderFns } from "./FreeBettingResult.vue?vue&type=template&id=054d8c0e&scoped=true"
import script from "./FreeBettingResult.vue?vue&type=script&lang=js"
export * from "./FreeBettingResult.vue?vue&type=script&lang=js"
import style0 from "./FreeBettingResult.vue?vue&type=style&index=0&id=054d8c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d8c0e",
  null
  
)

export default component.exports